module.exports = __webpack_public_path__ + "static/media/history.e720b29d.svg";